import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.after('initialize', function() {
        this.on(document, 'uiContestArchiveRequested', this.archive);
        this.on(document, 'uiContestUnarchiveRequested', this.unarchive);
    });

    this.archive = function(e, data) {
        var xhr = $.ajax({
            url: data.endpoint,
            data: data,
            type: 'PUT',
            headers: { Accept: 'application/json' },
        });

        xhr.done(
            function(res) {
                this.$node.trigger('dataContestArchiveSuccess', {
                    listingId: data.listingId,
                });
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.$node.trigger('dataContestArchiveError', {
                    listingId: data.listingId,
                });
            }.bind(this)
        );
    };

    this.unarchive = function(e, data) {
        var xhr = $.ajax({
            url: data.endpoint,
            data: data,
            type: 'PUT',
            headers: { Accept: 'application/json' },
        });

        xhr.done(
            function(res) {
                this.$node.trigger('dataContestUnarchiveSuccess', {
                    listingId: data.listingId,
                });
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.$node.trigger('dataContestUnarchiveError', {
                    listingId: data.listingId,
                });
            }.bind(this)
        );
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/data/archive.js